<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="voice-list"
            :url="url"
            :columns="columnList"
            :buttons="buttons"
            dialogWidth="80%"
            :addButton="{ enabled: false }"
            :tableHeight="tableHeight"
            :filterSpan="[18, 5]"
            :updateButton="{ enabled: false }"
            :showSequence="false"
            @loadNoticeView="loadNoticeView"
        >
            <template slot="filter">
                <el-col :md="7" :lg="5" :xl="3">
                    <item-input type="datearraw2" v-model="rdate" :clearable="false" size="mini"></item-input>
                </el-col>
            </template>
            <template slot="filter-after">
                <el-button type="primary" size="mini" @click="loadNoticeView">广播</el-button>
                <el-button type="primary" size="mini" @click="loadVoiceView">模板配置</el-button>
            </template>
        </crud-facecade>

        <el-dialog class="form-table-h380" title="语音模板" :visible.sync="voiceView.dialogFormVisible" :close-on-click-modal="false" width="80%">
            <cus-form ref="form-voice" :data="voiceData" :columns="voiceViewColumns" @extrabutton-click="ExtraButtonClick1"></cus-form>
            <ListView :columns="voiceViewTitleColumns" :datalist="voiceView.data" @extrabutton-click="ExtraButtonClick" class="table-h460"></ListView>
        </el-dialog>

        <el-dialog class="form-table-h380" :title="`通知 ${noticeTitle}`" :visible.sync="noticeView.dialogFormVisible" :close-on-click-modal="false" width="80%">
            <ListView :columns="noticeColumns" :datalist="noticeView.data" @extrabutton-click="ExtraButtonClick" class="table-h460"></ListView>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `BoardNotice`,
    props: {

    },
    data() {
        return {
            title: `大屏通知`,
            noticeTitle: ``,
            rdate: this.$moment().format(`YYYY/MM/DD`),
            url: {
                baseURL: `/api`,
                get: () => {
                    return this.ReloadListData()
                }
            },
            voiceView: {
                dialogFormVisible: false,
                data: []
            },
            surgery_status: [20, 30, 40, 50, 60],
            voiceTemplate: [],
            voiceData: {},
            noticeView: {
                dialogFormVisible: false,
                data: []
            },
            buttons: [{
                label: `通知`,
                type: `primary`,
                emit: `loadNoticeView`,
                permission: `default`,
                class: `is-plain`
            }],
            patient_info: ``,
            patient_name: ``,
            dic_operating_ward_id: ``,
            activePatient: {},
            templates: [],
            config: {}
        }
    },
    created() {
        this.init()
        this.loadVoiceTemplateList()
    },
    computed: {
        ...mapGetters([`screenHeight`, `active_ward`, `sys_enums`, `section_auth`, `operation_ward_auth`, `routers`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        operationRoom() {
            return this.active_ward && this.active_ward.operation_room && this.active_ward.operation_room.map(d => {
                d.code = ``
                return d
            }) || []
        },
        surgeryStatus() {
            return _.filter(this.sys_enums.SurgeryStatus, (d) => {
                return d.value !== 0 && d.value !== 10 && d.value !== -1
            }) || []
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `序号`,
                isKey: true
            }, {
                type: `string`,
                prop: `visit_no`,
                label: this.T(`board_notification.visit_no`),
                isListable: true,
                searchable: true
            }, {
                type: `string`,
                prop: `patient_name`,
                label: `患者姓名`,
                isListable: true,
                searchable: true
            }, {
                type: `string`,
                prop: `dic_section`,
                label: `科室`,
                isListable: true,
                searchable: true
            }, {
                type: `string`,
                prop: `sex`,
                label: `性别`,
                isListable: true
            }, {
                type: `string`,
                prop: `age`,
                label: `年龄`,
                width: `60`,
                isListable: false
            }, {
                type: `string`,
                prop: `bed_no`,
                label: `床号`,
                isListable: true
            }, {
                type: `select`,
                prop: `enum_surgery_status`,
                label: `手术状态`,
                isListable: true,
                searchable: true,
                clearable: true,
                options: this.surgeryStatus
            }, {
                type: `string`,
                prop: `dic_operating_room`,
                label: `手术间`,
                isListable: true,
                searchable: true,
                options: this.operationRoom
            }, {
                type: `string`,
                prop: `dic_recovery_bed`,
                label: `复苏床位`,
                isListable: true,
                searchable: true
            }, {
                type: `string`,
                prop: `surgeries`,
                label: `手术名称`,
                isListable: true
            }]
        },
        voiceViewTitleColumns() {
            return [{
                type: `string`,
                prop: `id`,
                label: `序号`,
                isKey: true
            }, {
                type: `string`,
                prop: `dic_operating_ward_name`,
                label: `手术区`,
                isListable: true
            }, {
                type: `string`,
                prop: `name`,
                label: `播报名称`,
                isListable: true
            }, {
                type: `string`,
                prop: `title`,
                label: `播报标题`,
                isListable: true
            }, {
                type: `string`,
                prop: `content`,
                label: `播报内容`,
                isListable: true
            }, {
                type: `string`,
                prop: `modify_date`,
                label: `最后修改时间`,
                isListable: true
            }, {
                type: `string`,
                prop: `modifier`,
                label: `最后修改人`,
                isListable: true
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `100`,
                readonly: false,
                isListable: true,
                options: [{
                    class: `is-plain`,
                    label: `删除`,
                    type: `danger`,
                    emit: `deleteTemplate`,
                    permission: `default`,
                    isListable: true
                }]
            }]
        },
        voiceViewColumns() {
            return [{
                type: `select`,
                prop: `dic_operating_ward_id`,
                label: `手术区`,
                colspan: 4,
                options: this.operation_ward_auth,
                default: this.currentOperWord
            }, {
                type: `string`,
                prop: `name`,
                label: `播报名称`,
                colspan: 4,
                validate: [{ required: true, message: `必填项目`, trigger: `change` }]
            }, {
                type: `string`,
                prop: `title`,
                label: `播报标题`,
                colspan: 4
            }, {
                type: `string`,
                prop: `content`,
                label: `播报内容`,
                colspan: 7,
                validate: [{ required: true, message: `必填项目`, trigger: `change` }]
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: ``,
                options: [{
                    label: `保存`,
                    type: `primary`,
                    emit: `saveVoiceTemplate`,
                    permission: `default`
                }, {
                    label: `重置`,
                    type: `default`,
                    emit: `resetVoiceTemplate`,
                    permission: `default`
                }],
                colspan: 4
            }]
        },
        currentOperWord() {
            this.dic_operating_ward_id = this.active_ward && this.active_ward.value
            let info = this.dic_operating_ward_id.split(`_`)
            if (info[0] == `ow`) {
                this.dic_operating_ward_id = parseInt(info[1])
            } else {
                this.dic_operating_ward_id = 0
            }
            return this.dic_operating_ward_id
        },
        noticeColumns() {
            return [{
                type: `string`,
                prop: `id`,
                label: `序号`,
                isKey: true
            }, {
                type: `string`,
                prop: `name`,
                label: `播报名称`,
                isListable: true
            }, {
                type: `string`,
                prop: `title`,
                label: `播报标题`,
                isListable: true
            }, {
                type: `string`,
                prop: `content`,
                label: `播报内容`,
                isListable: true
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `80`,
                readonly: false,
                isListable: true,
                options: [{
                    class: `is-plain`,
                    label: ``,
                    icon: `el-icon-microphone`,
                    type: `primary`,
                    emit: `broadCastNotice`,
                    permission: `default`,
                    isListable: true
                }]
            }]
        }
    },
    mounted() {

    },
    methods: {
        init() {
            return new Promise((resolve) => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/Get`)
                req.then((data) => {
                    this.config.boardConfigPageInterval = _.filter(data, { key: `BoardConfigPageInterval` })[0] && _.filter(data, { key: `BoardConfigPageInterval` })[0].value
                    this.config.boardConfigFamilyPrivate = _.filter(data, { key: `BoardConfigFamilyPrivate` })[0] && _.filter(data, { key: `BoardConfigFamilyPrivate` })[0].value
                    // this.config.boardConfigFontSize =  _.filter(data,{key:"BoardConfigFontSize"})[0]&&_.filter(data,{key:"BoardConfigFontSize"})[0].value
                    // this.config.boardConfigAudio =  _.filter(data,{key:"BoardConfigAudio"})[0]&&_.filter(data,{key:"BoardConfigAudio"})[0].value
                })
            })
        },
        ReloadListData() {
            return new Promise((resolve) => {
                let req = this.myaxios.post(`/api/Operation/Home/GetPatientList?date=${this.rdate}`, this.surgery_status)
                req.then(data => {
                    data = _.filter(data, { dic_operating_ward_id: this.currentOperWord })
                    data = _.orderBy(data, `dic_operating_room_order`) // ACIS-25213 按组织机构 手术间顺序排列
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                    resolve([])
                })
            })
        },
        loadVoiceTemplateList(id) {
            return new Promise((resolve) => {
                let req = this.myaxios.get(`/api/AcisSystem/BoardTemplate/Get`)
                req.then(data => {
                    this.templates = _.map(data, (d) => {
                        return {
                            id: d.id,
                            name: d.name,
                            title: d.title,
                            content: d.content,
                            modifier: d.modifier,
                            send_type: d.send_type,
                            modify_date: this.$moment(d.modify_date).format(`YYYY/MM/DD HH:mm`),
                            dic_operating_ward_id: d.dic_operating_ward_id,
                            dic_operating_ward_name: d.dic_operating_ward_name
                        }
                    })
                    let wardId = id === undefined ? this.dic_operating_ward_id : id
                    this.voiceView.data = _.filter(this.templates, (d) => {
                        // 消息模板那里设置了send_type=null,表示 家属屏大屏语音消息，send_type=1 表示其它语音播报，send_type=2 通知
                        return d.dic_operating_ward_id == wardId && !d.send_type
                    })
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadVoiceView() {
            this.voiceView.dialogFormVisible = true
        },
        resetVoiceTemplate() {
            this.voiceData = {}
        },
        saveVoiceTemplate({ formdata }) {
            let data = {
                id: this.voiceData && this.voiceData.id,
                name: formdata.name,
                title: formdata.title,
                content: formdata.content,
                dic_operating_ward_id: formdata.dic_operating_ward_id == null ? this.dic_operating_ward_id : formdata.dic_operating_ward_id
            }
            let req
            if (this.voiceData && this.voiceData.id) {
                req = this.myaxios.put(`/api/AcisSystem/BoardTemplate/Put`, data)
            } else {
                req = this.myaxios.post(`/api/AcisSystem/BoardTemplate/Post`, data)
            }
            req.then(data => {
                this.loadVoiceTemplateList(data.dic_operating_ward_id)
                this.voiceData = { dic_operating_ward_id: formdata.dic_operating_ward_id }
            }).catch(e => {
                console.log(e)
            })
        },
        deleteTemplate({ row, index }) {
            let that = this
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = that.myaxios.delete(`/api/AcisSystem/BoardTemplate/Delete/${row.id}`)
                req.then(data => {
                    this.voiceView.data.splice(index, 1)
                }).catch(e => { console.log(e) })
            })
        },
        ExtraButtonClick(target) {
            this[target.emit](target)
        },
        ExtraButtonClick1(target) {
            this[target.emit](target)
        },
        broadCastNotice({ row }) {
            console.log(row)
            console.log(this.activePatient)
            let r = []
            if (this.config.boardConfigFamilyPrivate === `true`) {
                r = this.patient_name.split(``)
                r[1] = r[0] ? `*` : ``
                r = r.join(``)
            } else {
                r = this.patient_name
            }
            let roomId = 0
            let bedId = 0
            if (this.activePatient && (this.activePatient.enum_surgery_status == 50 || this.activePatient.enum_surgery_status == 60)) {
                roomId = 0
                bedId = this.activePatient.dic_recovery_bed_id || 0
            } else {
                roomId = this.activePatient.dic_operating_room_id || 0
                bedId = 0
            }

            let title = row.title == null ? `` : row.title
            let msgData = `{
          "id":"${this.$moment()}",
          "readText":"请${this.patient_info}${this.patient_name}${title} ${row.content}",
          "disaplayText":"请${this.patient_info}${r}${title} ${row.content}",
          "receiver":"${this.active_ward.value}",
          "type":"DP",
          "roomId":${roomId},
          "bedId":${bedId}
        }`
            let req = this.myaxios.post(`/api/Operation/BoardNotice/SendMessage?msg=${msgData}`)
            req.then(data => {
                this.$message.info(`已通知`)
            }).catch(e => {
                console.log(e)
            })
        },
        rowClick({ row }) {
            this.voiceData = row
        },
        loadNoticeView({ row }) {
            this.activePatient = row
            this.patient_name = ``
            this.patient_info = ``
            this.noticeTitle = ``
            if (row && row.patient_name) {
                if (row.dic_section) {
                    this.patient_info += row.dic_section
                }
                if (row.bed_no) {
                    this.patient_info += row.bed_no + `床`
                }
                this.patient_name = row.patient_name
                this.noticeTitle = row.patient_name
            }
            this.noticeView.data = this.voiceView.data
            this.noticeView.dialogFormVisible = true
        }
    },
    watch: {
        rdate: function() {
            this.$refs[`voice-list`].ReloadListData()
        },
        dic_operating_ward_id: function(newId, oldId) {
            this.$refs[`voice-list`].ReloadListData()
            this.loadVoiceTemplateList()
        }
    },
    destroyed() {

    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Board/BoardNotice.vue